import { IHasStopPointType } from '../models/has-stop-point-type';
import { StopPointType } from '../models/stop-point-type.enum';
import { t } from '../services/texts.service';

export class StopPointHelper {
  public static mapToStopPointType(stopPointType: string): StopPointType {
    switch (stopPointType) {
      case StopPointType.trainStop:
        return StopPointType.trainStop;
      case StopPointType.other:
        return StopPointType.other;
      default:
        return StopPointType.unknown;
    }
  }

  public static stopPointTypeTranslation(hasStopPointType: IHasStopPointType): string {
    if (hasStopPointType.stopPointType === StopPointType.trainStop) {
      return t.track;
    }
    return t.platform;
  }
}
